var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":"전체"}},[_c('InsightTotal')],1),_c('vs-tab',{attrs:{"label":"출석부"}},[_c('InsightAttend')],1),_c('vs-tab',{attrs:{"label":"프로젝트"}},[_c('InsightProject')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }